/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RegionHubsQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type RegionHubsQuery = {
  __typename?: 'Query'
  serviceBreakLocations: {
    __typename?: 'ServiceBreakLocationsResponse'
    serviceBreakLocations: Array<{
      __typename?: 'ServiceBreakLocation'
      id: string
      name: string
    }>
  }
}

export const RegionHubsDocument = gql`
    query regionHubs($regionId: ID!) {
  serviceBreakLocations(
    input: {regionId: $regionId, filters: {states: [ACTIVE], types: HUB}}
  ) {
    serviceBreakLocations {
      id
      name
    }
  }
}
    `

/**
 * __useRegionHubsQuery__
 *
 * To run a query within a React component, call `useRegionHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionHubsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useRegionHubsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegionHubsQuery,
    RegionHubsQueryVariables
  > &
    (
      | { variables: RegionHubsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RegionHubsQuery, RegionHubsQueryVariables>(
    RegionHubsDocument,
    options,
  )
}
export function useRegionHubsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegionHubsQuery,
    RegionHubsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RegionHubsQuery, RegionHubsQueryVariables>(
    RegionHubsDocument,
    options,
  )
}
// @ts-ignore
export function useRegionHubsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RegionHubsQuery,
    RegionHubsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RegionHubsQuery, RegionHubsQueryVariables>
export function useRegionHubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegionHubsQuery,
        RegionHubsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RegionHubsQuery | undefined,
  RegionHubsQueryVariables
>
export function useRegionHubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegionHubsQuery,
        RegionHubsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RegionHubsQuery, RegionHubsQueryVariables>(
    RegionHubsDocument,
    options,
  )
}
export type RegionHubsQueryHookResult = ReturnType<typeof useRegionHubsQuery>
export type RegionHubsLazyQueryHookResult = ReturnType<
  typeof useRegionHubsLazyQuery
>
export type RegionHubsSuspenseQueryHookResult = ReturnType<
  typeof useRegionHubsSuspenseQuery
>
export type RegionHubsQueryResult = Apollo.QueryResult<
  RegionHubsQuery,
  RegionHubsQueryVariables
>
